export enum MonetizationOption {
    Dynamic = 'dynamic',
    Free = 'free',
    Paid = 'paid',
}
